import { jsx as _jsx } from "react/jsx-runtime";
import { components } from 'react-select';
import DIcon from '../../DIcon';
import { useDContext } from '../../../contexts';
export default function DSelectClearIndicator(props) {
    const { iconMap: { x, }, } = useDContext();
    return (_jsx(components.ClearIndicator, Object.assign({}, props, { children: _jsx(DIcon, { icon: x }) })));
}
//# sourceMappingURL=DSelectClearIndicator.js.map